var TYPEKIT = {
  SP_URL: 'https://use.typekit.net/xbm1wuz.css'
};
export default TYPEKIT;